import { Spinner } from '../elements/spinner.element.jsx';
import { Text } from '../elements/text.element.jsx';

export const LoadingState = ({ label = 'Loading...' }) => (
  <div className="flex flex-col items-center justify-center p-12 space-y-4">
    <Spinner />
    <Text variant="label" className="animate-pulse">{label}</Text>
  </div>
);